<script lang="ts">
  import {page} from '$app/stores';
  import {locale} from "$lib/i18n";
</script>

<main class="bg-primary-dark">
  <h1>{$page.status}: {$page?.error?.message}</h1>

  {#if $page.status === 404}
    <p>We're sorry, but the page you're looking for doesn't exist.</p>
  {:else}
    <p>An unexpected error occurred. Our team has been notified.</p>
  {/if}

  <a href="/{$locale}">Return to Home</a>
</main>

<style>
  main {
    text-align: center;
    padding: 2em;
    max-width: 800px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    font-size: 2.5em;
    margin-bottom: 0.5em;
  }

  a {
    display: inline-block;
    margin-top: 2em;
    padding: 0.5em 1em;
    background-color: #ff3e00;
    color: white;
    text-decoration: none;
    border-radius: 4px;
  }

  a:hover {
    background-color: #ff6340;
  }
</style>
